
import https from '@/utils/http'
let a = []
const app = {
     // 根据分类获取模版
     getTemplate(){
        return https({
            url:'/api/public/gpt/getTemplate',
            method:"GET",
            isToken:'no',
        })
    },
    // 获取AI绘画模版
    getAIPaintingTemplate(){
        return https({
            url:'/api/public/gpt/getAIPaintingTemplateV1',
            method:"GET",
            isToken:'no',
        })
    },
    // 获取我的应用
    getMyTemplate(params){
        return https({
            url:'/api/public/gpt/myTemplate',
            method:"GET",
            params
        })
    },
    // 创建/修改我的模版
    getCreateTemplate(data){
        return https({
            url:'/api/public/gpt/createTemplate',
            method:"POST",
            data
        })
    },
    // 操作模版(删除/修改)
    getUpdateMyTemplate(data){
        return https({
            url:'/api/public/gpt/updateMyTemplate',
            method:"POST",
            data
        })
    },
    // 用于点赞绘画模版和应用模版
    getUpTemplate(data,type){
        return https({
            url:type == 'app' ? '/api/public/gpt/upTemplate' : '/api/public/gpt/upAIPaintingTemplate',
            method:"POST",
            data
        })
    },
    // 根据关键词查询模版
    searchTemplate(params){
        return https({
            url:'/api/public/gpt/searchTemplate',
            method:"GET",
            params
        })
    }
    
}
export default app;